module.exports = __webpack_public_path__ + "img/album17_24.ea9d303d.jpg";